import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import SelectRow from "../../components/Select/SelectRow";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import { Utilites } from "../../core/Utilites";

export default class ServiceAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      name: "",
      city: "",
      citylist: [],
      icon: "",
      isImageChanged: false,
      loading: false,
    };
    this.pathname = "services";
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const edit = this.props.location.data;
    if (edit) {
      this.setState({
        ...edit,
      });
    }
    this.prepareData();
  }

  async prepareData() {
    let responseuni = await this.engine.getItemlistDirect("cities");
    if (responseuni) {
      const data = responseuni.data.items;
      let citylist = data.map((p) => ({ value: p.id, label: p.name }));
      this.setState({ citylist });
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, city, isImageChanged, ...data } = this.state;
    let response;

    let postData;

    try {
      if (id) {
        if (!isImageChanged) delete data.icon;
        else data["icon"] = this.idFileBase64;
        response = await this.engine.updateItem(this.pathname, id, data);
      } else {
        const { id, name, cityId } = this.state;
        postData = {
          id,
          name,
          icon: this.idFileBase64,
          cityId,
        };
        // Create new service
        response = await this.engine.saveItem(this.pathname, postData);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push("/admin/" + this.pathname);
      }
    } catch (err) {
      const errorMessageArray = err.response?.data?.message;

      if (errorMessageArray && Array.isArray(errorMessageArray)) {
        // Filter out only the message "cityId should not be empty"
        let filteredErrors = errorMessageArray.filter((msg) =>
          msg.includes("cityId should not be empty")
        );
        filteredErrors.push(
          errorMessageArray.filter((msg) =>
            msg.includes("icon should not be empty")
          )
        );
        // If the specific error is found, replace "cityId" with "city" and display the modified message
        if (filteredErrors.length > 0 || filteredErrors.length > 1) {
          const finalErrorMessage =
            filteredErrors[0].replace("cityId", "city") +
            ", " +
            filteredErrors[1];
          // Display this message in the UI (alert, toast, or inline message)
          alert(finalErrorMessage);
        } else alert(`Error: ${errorMessageArray}`);
      } else {
        // Handle general errors
        alert("An unexpected error occurred: " + err.message);
      }
    }

    this.setState({ loading: false });
  };

  onChangePic(e) {
    if (!e.target.files[0]) {
      return; // No file selected, return early
    }

    Utilites.getFileBase64(e.target.files[0], (result) => {
      this.setState({ icon: result, isImageChanged: true });
      this.idFileBase64 = result; // Only update if new file is selected
    });
  }

  render() {
    const { id, loading, isLoading, name, citylist, city, icon } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormRow
                    label={strings.name}
                    name="name"
                    data={name}
                    changeInput={this.changeInput}
                  />
                  {!id && (
                    <SelectRow
                      label={strings.city}
                      name="cityId"
                      defaultValue={city}
                      data={citylist}
                      required={true}
                      changeInput={this.changeInput.bind(this)}
                    />
                  )}
                  <Row>
                    <Label sm="2">{strings.picture}</Label>
                    <Col sm="5">
                      <FormGroup>
                        <ImageUpload
                          placeholder={
                            icon || `${strings.select} ${strings.picture}`
                          } // Display the selected or existing image
                          labelupload={`${strings.select} ${strings.picture}`}
                          onChange={(e) => this.onChangePic(e)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
